import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Form, Input, Button, Select } from "antd";
import { Spin, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Navigate, useNavigate } from "react-router-dom";
import { inviteUser, getOrganizations } from "../../utils/api";
import "./AddUser.css";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />
);
const { Option } = Select;

function AddUser({ navStore, authStore }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("user");
  const [organization, setOrganization] = useState("");
  const [organizationList, setOrganizationList] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const onFinish = async () => {
    setError("");
    setSubmitting(true);
    try {
      let organization_ = organization;
      if (authStore.userRole === "org_admin") {
        organization_ = authStore.user.organization_details.name;
        setOrganization(organization_);
      }
      await inviteUser(email, firstName, lastName, role, organization_);
      notification.open({
        message: "User Invited",
        description: "User Invited Successfully",
      });
      navigate("/user");
    } catch (e) {
      setSubmitting(false);
      setError(e.response.data.message);
    } finally {
      setSubmitting(false);
    }
  };

  const fetchOrganizations = async () => {
    const orgs = await getOrganizations();
    setOrganizationList(orgs);
  };
  useEffect(() => {
    navStore.selectedKey = "2";
    fetchOrganizations();
  }, []);

  return (
    <div className="AddUser">
      <div className="AddUser__wrapper">
        <div className="AddUser__container">
          <h2>Invite a user</h2>
          <Form
            name="basic"
            initialValues={{ remember: true }}
            autoComplete="off"
            layout="vertical"
            onFinish={onFinish}
          >
            <Form.Item
              className="AddUser__item"
              label="First name"
              name="name"
              rules={[{ required: true, message: "Please enter first name" }]}
            >
              <Input onChange={(e) => setFirstName(e.target.value)} />
            </Form.Item>

            <Form.Item
              className="AddUser__item"
              label="Last name"
              name="lastname"
              rules={[{ required: true, message: "Please enter last name" }]}
            >
              <Input onChange={(e) => setLastName(e.target.value)} />
            </Form.Item>

            <Form.Item
              className="AddUser__item"
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter an email" }]}
            >
              <Input onChange={(e) => setEmail(e.target.value)} />
            </Form.Item>

            <Form.Item
              className="AddUser__item"
              label="Role"
              name="role"
              rules={[{ required: true, message: "Please select a role" }]}
            >
              <Select defaultValue="" style={{}} onChange={(e) => setRole(e)}>
                <Option value="">Select Role</Option>
                {/* <Option value="org_user">User</Option> */}
                {["admin"].indexOf(authStore.userRole) >= 0 && (
                  <Option value="admin">Super Admin</Option>
                )}
                <Option value="org_admin">Organization Admin</Option>
                <Option value="org_supervisor">Organization Supervisor</Option>
                <Option value="org_user">Org User</Option>
              </Select>
            </Form.Item>

            {(role === "org_supervisor" ||
              role === "org_admin" ||
              role === "org_user") &&
              ["admin"].indexOf(authStore.userRole) >= 0 && (
                <Form.Item
                  className="AddUser__item"
                  label="Organization"
                  name="organization"
                  rules={[
                    {
                      required: true,
                      message: "Please select an organization",
                    },
                  ]}
                >
                  <Select
                    defaultValue=""
                    style={{}}
                    onChange={(e) => setOrganization(e)}
                  >
                    <Option value="">Select Organization</Option>
                    {organizationList.map((x) => {
                      return <Option value={x.name}>{x.name}</Option>;
                    })}
                  </Select>
                </Form.Item>
              )}

            {error && <div className="error">{error}</div>}
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                {submitting && <Spin indicator={antIcon} />}
                {!submitting && <span> Invite</span>}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default observer(AddUser);
